export const ID_RESIDENZ47 = 64;
export const ID_ESPLANADE = 35;

export default Object.freeze({
  ID_RESIDENZ47,
  ID_ESPLANADE,
});
